module.exports = __webpack_public_path__ + "static/media/wsks.1a7250e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/wsks.png
// module id = 428
// module chunks = 0